import React from 'react';

const SvgDz = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="DZ_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="DZ_svg__b" fill="#fff">
        <use xlinkHref="#DZ_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path fill="#048345" mask="url(#DZ_svg__b)" d="M0 0h14.667v20H0z" />
      <path
        fill="#E81B42"
        mask="url(#DZ_svg__b)"
        d="M17.333 11.04l-1.567 1.117.578-1.836-1.547-1.145 1.925-.017.611-1.826.612 1.826 1.924.017-1.547 1.145.579 1.836z"
      />
      <path
        d="M17.68 5.619a5.483 5.483 0 0 0-2.36-.528c-2.888 0-5.229 2.198-5.229 4.909s2.34 4.91 5.228 4.91c.85 0 1.652-.191 2.361-.529A5.605 5.605 0 0 1 13.75 16C10.576 16 8 13.314 8 10s2.575-6 5.75-6c1.52 0 2.902.615 3.93 1.619z"
        fill="#E81B42"
        mask="url(#DZ_svg__b)"
      />
    </g>
  </svg>
);

export default SvgDz;
